import * as React from 'react';
import { Button, toast } from '@repo/ui-web';

export function ToastShowcase() {
  const [sticky, setSticky] = React.useState(false);

  return (
    <div className="space-y-4">
      <div className="flex flex-wrap gap-2">
        <Button
          size="md"
          variant={!sticky ? 'default' : 'outline'}
          onClick={() => setSticky(false)}
          type="button"
        >
          Temporal
        </Button>
        <Button
          size="md"
          variant={sticky ? 'default' : 'outline'}
          onClick={() => setSticky(true)}
          type="button"
        >
          Sticky
        </Button>
      </div>
      <div className="flex flex-wrap gap-2">
        <Button
          size="md"
          variant="outline"
          onClick={() =>
            toast({
              title: 'Profile updated',
              description: 'Your changes have been saved.',
              variant: 'info',
              sticky,
            })
          }
        >
          Show info
        </Button>
        <Button
          size="md"
          onClick={() =>
            toast({
              title: 'Billing complete',
              description: 'Invoice has been sent.',
              variant: 'success',
              sticky,
            })
          }
        >
          Show success
        </Button>
        <Button
          size="md"
          variant="secondary-outline"
          onClick={() =>
            toast({
              title: 'Storage almost full',
              description: 'You have less than 5% space remaining.',
              variant: 'warning',
              sticky,
            })
          }
        >
          Show warning
        </Button>
        <Button
          size="md"
          variant="destructive"
          onClick={() =>
            toast({
              title: 'Payment failed',
              description: 'Update your card details.',
              variant: 'destructive',
              sticky,
            })
          }
        >
          Show error
        </Button>
      </div>
    </div>
  );
}
